import { render, staticRenderFns } from "./chatGroupSettingsDialog.vue?vue&type=template&id=479c67ef&scoped=true"
import script from "./chatGroupSettingsDialog.vue?vue&type=script&lang=js"
export * from "./chatGroupSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./chatGroupSettingsDialog.vue?vue&type=style&index=0&id=479c67ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479c67ef",
  null
  
)

export default component.exports